module.exports = __webpack_public_path__ + "static/rfa-adi@2x-1-768x452-99c8686b2704fbb0524a4d065cf3deb2.png";